import { useCallback } from 'react';

import { useOnboardingClient, useOnboardingSettingsSave } from 'api/requests';
import { OnboardingProcessStepNameType } from 'api/types/entity';

export const useOnboarding = (clientId: string) => {
  const { currentClient, loading, refetch } = useOnboardingClient(clientId);
  const { saveSettings } = useOnboardingSettingsSave();

  const onGoBack = useCallback(
    async (name: OnboardingProcessStepNameType) => {
      if (currentClient) {
        await saveSettings(currentClient.id, name);
      }
    },
    [currentClient, saveSettings]
  );

  const totalStepCount = currentClient?.onboarding?.process?.totalStepCount;

  return {
    currentClient,
    loading: !currentClient && loading,
    totalStepCount,
    onGoBack,
    refetch,
  };
};
